<template>
  <div class="rank">
    <h4 class="title">{{ title }}</h4>
    <!--    <ul class="list">-->
    <!--      <li :key="index" v-for="(item, index) in list">-->
    <!--        <span :class="index < 3 ? 'active' : null">{{ index + 1 }}</span>-->
    <!--        <span>{{ item.name }}</span>-->
    <!--        <span>{{ item.total }}</span>-->
    <!--      </li>-->
    <!--    </ul>-->
    <div class="rank-list-container">
      <a-row :key="index" v-for="(item, index) in list" style="marginTop:5px;line-height: 2.5">
        <a-col :span="2">
          <a-avatar :size="20"
                    :style="{background: index<3?'#314659':'#f5f5f5',color: index<3?'white':'black',fontSize:'12px'}">
            {{ index + 1 }}
          </a-avatar>
        </a-col>
        <a-col :span="18" class="rank-item-name"><a-tooltip placement="topLeft" :title="item.name">{{ item.name }}</a-tooltip></a-col>
        <a-col :span="4" style="float:right;textAlign:right">{{ item.total }}</a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankList',
  // ['title', 'list']
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.title{
  margin-left: 10px;
}
.rank{
  font-weight: 700;
  margin: 0 10px 10px 20px;
  padding: 0 10px 10px 10px;
}
.rank-item-name {
  color: rgba(0,0,0,.65);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank-list-container{
  margin: 20px 10px 10px 10px;
  pading: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Charts/RankList.vue